
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/_gelderland/vacatures/[id]",
      function () {
        return require("private-next-pages/_sites/_gelderland/vacatures/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/_gelderland/vacatures/[id]"])
      });
    }
  